import { CSSProperties } from '@material-ui/styles';
import React, { FC } from 'react';

interface BannerProps {
  imageUrl?: string;
  height?: number;
  position?: string;
}

const Banner: FC<BannerProps> = ({
  imageUrl,
  height,
  position
}: BannerProps) => {
  if (imageUrl === undefined || imageUrl.length === 0) {
    return null;
  }

  let style: CSSProperties = {
    height: height ?? 320,
    width: '100%',
    objectFit: 'cover'
  };
  if (position === 'bottom') {
    style = {
      ...style,
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0
    };
  }

  return <img src={imageUrl} style={style} alt={`${position} banner`} />;
};

export default Banner;
